<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-claim-view />

    <core-footer />

  </v-app>
</template>

<script>

export default {
  name: 'Claim',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreClaimView: () => import('../components/core/ClaimView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
